import React from "react";

export default function UniComplyLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.24057 0.759277H16.4906C16.6895 0.759277 16.8802 0.838295 17.0209 0.978947C17.1616 1.1196 17.2406 1.31036 17.2406 1.50928V12.7593C17.2406 12.9582 17.1616 13.149 17.0209 13.2896C16.8802 13.4303 16.6895 13.5093 16.4906 13.5093C16.2917 13.5093 16.1009 13.4303 15.9602 13.2896C15.8196 13.149 15.7406 12.9582 15.7406 12.7593V3.31928L2.02057 17.0393C1.87839 17.1718 1.69035 17.2439 1.49605 17.2405C1.30175 17.237 1.11636 17.1583 0.978947 17.0209C0.841534 16.8835 0.762822 16.6981 0.759394 16.5038C0.755966 16.3095 0.828089 16.1215 0.960569 15.9793L14.6806 2.25928H5.24057C5.04166 2.25928 4.85089 2.18026 4.71024 2.03961C4.56959 1.89896 4.49057 1.70819 4.49057 1.50928C4.49057 1.31036 4.56959 1.1196 4.71024 0.978947C4.85089 0.838295 5.04166 0.759277 5.24057 0.759277Z"
        fill="url(#paint0_linear_127_80)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_127_80"
          x1="0.299028"
          y1="0.759277"
          x2="21.164"
          y2="2.3997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35D7E4" />
          <stop offset="1" stopColor="#0A829D" />
        </linearGradient>
      </defs>
    </svg>
  );
}
